import { useAppSelector } from "store/hooks";
import { useProject } from "utils/hooks/useProject";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";
import useTranslation from "utils/hooks/useTranslation";

const InputData: React.FC = () => {
    const { t } = useTranslation();
    const { isThermor } = useSalesNetwork();
    const projectStore = useAppSelector((state) => state.project);
    //const heatModeStep = useAppSelector((state) => state.heatMode);
    //const coolModeStep = useAppSelector((state) => state.coolMode);
    const { getValue } = useProject();
    const departement = getValue("forms.heatModeStep.form.departement");
    const stationMeteo = getValue("forms.heatModeStep.form.stationMeteo");
    const altitude = getValue("forms.heatModeStep.form.altitude");
    const deperditions_temperature = getValue("forms.heatModeStep.form.deperditions.temperature");
    const temperature = getValue("forms.coolModeStep.form.temperature");

    return (
        <>
            <group data-direction="column" data-length="autofit" data-justify="start"
                {...(isThermor ? {"data-border-color": "main-color-custom-border", "data-space": "20", "data-space-bottom": "0"} : {  })}
                >
                <text
                    data-weight="600"
                    data-text-size="22"
                    data-ellipsis=""
                    data-space="5"
                >
                    {t("INPUT_DATA")}
                </text>

                <group data-align="center" data-gap="5" data-space="5"><text>{t("DEPARTMENT")} :</text><text data-text-size="large" data-weight="600">{departement}</text></group>
                <group data-align="center" data-gap="5" data-space="5"><text>{t("CITY")} :</text><text data-text-size="large" data-weight="600">{stationMeteo}</text></group>
                <group data-align="center" data-gap="5" data-space="5"><text>{t("ALTITUDE")} :</text><text data-text-size="large" data-weight="600">{altitude}&nbsp;m</text></group>
                <group data-align="center" data-gap="5" data-space="5"><text>{t("WINTER_ROOM_TEMP")} :</text><text data-text-size="large" data-weight="600">{deperditions_temperature}&nbsp;°C</text></group>
                {projectStore.project.simulationCool && <>
                    <group data-align="center" data-gap="5" data-space="5"><text>{t("SUMMER_ROOM_TEMP")} :</text><text data-text-size="large" data-weight="600">{temperature}&nbsp;°C</text></group></>
                }
            </group>
        </>
    )
}

export default InputData;